let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ak04Q")).then(() => parcelRequire('8LFW3'));